export default __webpack_public_path__ + "static/media/SAS0020.34I-32342_-17811_0.c133a869.jpg";